import YFormDateLabel from './DateLabel';

export { YFormDateLabel };
export default YFormDateLabel;
